import { urls } from '@ff-os/shared-utils/urls';

let worker: Worker | undefined;

/**
 * Creates a singleton instance for the face detection web worker. It will return
 * the same instance if called multiple times. For non-browser environments, it will
 * return undefined.
 */
export const createFaceDetectionWebWorker = async () => {

    const isNodeEnvironment = typeof Blob === 'undefined';
    if (isNodeEnvironment) {
        return;
    }

    const { canRunFaceDetection, createWebWorker } = await importFaceDetectionModule();
    if (!canRunFaceDetection()) {
        return;
    }

    if (worker) {
        return worker;
    }

    worker = createWebWorker(urls.getFaceDetectionModels);
    return worker;
};

export const importFaceDetectionModule = () => {
    return import(
        /* webpackChunkName: "ff-object-detection" */
        /* webpackPreload: true */
        'ff-face-detection'
    );
};